import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

import { apolloClient } from 'lib/withApollo'
// import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import ARTICLE_QUERY from 'graphql/article.query'

import Loading from 'components/Loading'
import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import ArticleTemplate from 'components/ArticleTemplate'

function Article({ post, site, slug, globalSettings }) {
  const router = useRouter()
  if (router.fallback || !post) return <Loading />

  // todo: if no 'post' set by this point we should show the 404 instead of Loading

  return (
    <Layout globalSettings={globalSettings}>
      <WordpressSEO
        url={`/${site}/article/${slug}`}
        seo={post.seo}
        title={post.title}
      />
      <ArticleTemplate data={{ postBy: post }} />
    </Layout>
  )
}

Article.propTypes = {
  site: PropTypes.string,
  slug: PropTypes.string,
  post: PropTypes.object,
  globalSettings: PropTypes.object,
}
Article.defaultProps = {
  site: '',
  slug: '',
  post: null,
  globalSettings: {},
}

export default Article

export async function getStaticProps({ params }) {
  const { site, slug } = params
  const { data, error } = await apolloClient().query({
    query: ARTICLE_QUERY,
    context: { site },
    variables: { slug },
  })

  if (error) console.log(`Error loading Article props - ${error}`)

  return {
    props: {
      ...params,
      post: data.postBy,
    },
    revalidate: 60 * 2,
  }
}

export async function getStaticPaths() {
  const paths = []

  // const sites = await getSitesForStaticPaths(
  //   ({ site, offset }) => ({
  //     query: POSTS_QUERY,
  //     context: { site },
  //     variables: {
  //       featuredInBlocks: true,
  //       offset,
  //       limit: 100,
  //     },
  //   }),
  //   data => data.posts.nodes,
  //   data => data.posts.pageInfo.offsetPagination.hasMore
  // )

  // sites.forEach(site => {
  //   site[1].forEach(p => {
  //     paths.push({
  //       params: {
  //         site: site[0],
  //         slug: p.slug,
  //       },
  //     })
  //   })
  // })

  return {
    paths,
    fallback: true,
  }
}
